import { render, staticRenderFns } from "./StoreNav.vue?vue&type=template&id=0da96138&scoped=true&"
import script from "./StoreNav.vue?vue&type=script&lang=js&"
export * from "./StoreNav.vue?vue&type=script&lang=js&"
import style0 from "./StoreNav.vue?vue&type=style&index=0&id=0da96138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da96138",
  null
  
)

export default component.exports